module.exports = __webpack_public_path__ + "img/wdsx-icon.378ed0b4.png";